import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getGoogleAccountsCount() {
  return axios.get('/ajax/google_accounts/count')
}

export function getGoogleAccounts(params = {}) {
  return axios.get('/ajax/google_accounts', { params })
}

export function getGoogleAccount(id) {
  return axios.get(`/ajax/google_accounts/${id}`)
}

export function deleteGoogleAccount(id) {
  return axios.delete(`/ajax/google_accounts/${id}`)
}

export function refreshGoogleAccount(id, params = {}) {
  return axios.post(`/ajax/google_accounts/${id}/refresh`, params)
}

export function getSearchConsoleSites(id, params = {}) {
  return axios.get(`/ajax/google_accounts/${id}/search_console_sites`, { params })
}

export function getAnalyticsProperties(id, params = {}) {
  return axios.get(`/ajax/google_accounts/${id}/analytics_properties`, { params })
}
